/* template */
<template><success-popup :show="(showSuccessPopup)" :type="(type)" @close="triggerSuccessPopup"/></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m5c7fe3a1"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m5c7fe3a1"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex5c7fe3a1%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex5c7fe3a1%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m5c7fe3a1"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index5c7fe3a1/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'success-popup':getComponent(require("./success-popup.mpx?isComponent&outputPath=components%2Fsuccess-popup51283d9e%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
